import axios from 'axios';
import * as React from 'react';
import { requestCreateApPlanAction } from '../asyncHelpers/actionPlanService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { ApPlanAction, CreateApPlanActionRequest } from '../sic-lib/types/ApPlanAction';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncCreateApPlanAction
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestCreateApPlanAction HTTP request
 * */
export default function useAsyncCreateApPlanAction() {
    const request_token = axios.CancelToken.source();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncCreateApPlanAction = async (
        planId: number,
        apAction: CreateApPlanActionRequest,
    ): Promise<ApPlanAction | undefined> => {
        try {
            setRequestStatus(RequestStatus.none);

            const { data } = await requestCreateApPlanAction(planId, apAction, request_token.token);

            setRequestStatus(RequestStatus.success);

            return data;
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast('Error while creating Action Plan action');

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncCreateApPlanAction,
    };
}
